/**
 * UpdateNotification - Shows a notification when a new app version is available
 */
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RefreshCw, X, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { useVersionCheck } from '../../hooks/useVersionCheck';

export function UpdateNotification() {
  const { updateAvailable, newVersion, forceUpdate, dismissUpdate } = useVersionCheck();

  return (
    <AnimatePresence>
      {updateAvailable && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-96 z-50"
        >
          <div className="bg-gradient-to-r from-orange-500 to-amber-500 rounded-xl shadow-2xl shadow-orange-500/25 p-4 text-white">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <Sparkles className="w-5 h-5" />
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-sm">
                  Nova versão disponível!
                </h4>
                <p className="text-xs text-white/80 mt-0.5">
                  Versão {newVersion} • Atualize para ter as últimas melhorias
                </p>
                
                <div className="flex gap-2 mt-3">
                  <Button
                    size="sm"
                    onClick={forceUpdate}
                    className="bg-white text-orange-600 hover:bg-white/90 font-medium text-xs h-8"
                    data-testid="update-now-btn"
                  >
                    <RefreshCw className="w-3 h-3 mr-1.5" />
                    Atualizar agora
                  </Button>
                  <Button
                    size="sm"
                    variant="ghost"
                    onClick={dismissUpdate}
                    className="text-white/80 hover:text-white hover:bg-white/10 text-xs h-8"
                    data-testid="dismiss-update-btn"
                  >
                    Depois
                  </Button>
                </div>
              </div>
              
              <button
                onClick={dismissUpdate}
                className="flex-shrink-0 text-white/60 hover:text-white transition-colors"
                aria-label="Fechar"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
